module.exports = __webpack_public_path__ + "static/d411e8ee7a62434b068c9c06d24735d8.svg";